// main product slider ==============

function lightboxSliderHeight() {
  if (window.innerWidth >= 1025) {
    // var height = document.querySelector(".lightbox-product-wraper .thumbnail-slider .swiper-wrapper").offsetHeight;
    // console.log(document.querySelector(".product.lightbox-product-wraper .slider-main-media").offsetHeight,height)
    // document.querySelector(".product--thumbnail_slider .swiper-container").style.height = `${document.querySelector(".product.lightbox-product-wraper .slider-main-media").offsetHeight}px`;
  }
}

var galleryThumbs;
var galleryMain;

function lightboxSlider() {
  lightboxSliderHeight();
  window.addEventListener('resize', function(event){
    lightboxSliderHeight();
  });
  galleryThumbs = new Swiper(".product.lightbox-product-wraper .thumbnail-slider", {
    slidesPerView: 'auto',
    freeMode: true,
    spaceBetween: 5,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-button-next-thumb-light-box',
      prevEl: '.swiper-button-prev-thumb-light-box'
    },
    breakpoints: {
             480: {
              slidesPerView: 'auto'
            },
            798: {
              slidesPerView: 'auto'
            },
            1025: {
              direction: 'vertical'
            },
            1200: {
              direction: 'vertical'
            },
          }
  });
  
  galleryMain = new Swiper(".product.lightbox-product-wraper .slider-main-media", {
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    autoHeight : true,
    navigation: {
      nextEl: '.swiper-button-next-light-box',
      prevEl: '.swiper-button-prev-light-box'
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });

  $(".swiper-button-next-thumb-light-box").click(function(e){
    galleryMain.slideNext();
  });
  $(".swiper-button-prev-thumb-light-box").click(function(e){
    galleryMain.slidePrev();
  });
}
lightboxSlider();


//  custom video section

$(".video-wrapper").each(function () {
  var $wrapper = $(this);
  $(".video video", $wrapper).each(function () {
    var videoElement = this;
    var $parent = $(this).parent();

    if (!$wrapper.hasClass("is_autoplay")) {
      $parent.off("mouseover mouseout");

      $parent.on("mouseover", function () {
        if (window.innerWidth >= 990) {
          $parent.addClass("is_playing");
          videoElement.play();
        }
      });

      $parent.on("mouseout", function () {
        if (window.innerWidth >= 990) {
          $parent.removeClass("is_playing");
          videoElement.pause();
        }
      });
    }

    $parent.off("click").on("click", function (e) {
      if (
        window.innerWidth < 990 &&
        videoElement.getAttribute("data-auto-play") === "false"
      ) {
        if ($parent.hasClass("is_playing")) {
          $parent.removeClass("is_playing");
          videoElement.pause();
        } else {
          $parent.addClass("is_playing");
          videoElement.play();
          videoElement.addEventListener("ended", function () {
            $parent.removeClass("is_playing");
          });
        }
      } else if (
        window.innerWidth < 990 &&
        videoElement.getAttribute("data-auto-play") === "true"
      ) {
        $(".video").removeClass("is_playing");
        $(".video-wrapper video").each(function () {
          var videoGetid = $(this).attr("id");
          var videoElementpause = document.getElementById(videoGetid);
          videoElementpause.playsinline = true;
          videoElementpause.pause();
          videoElementpause.currentTime = 0;
        });
        $parent.addClass("is_playing");
        videoElement.play();
        videoElement.addEventListener("ended", function () {
          $parent.removeClass("is_playing");
        });
      }
    });
  });
});


if (window.innerWidth < 990) {
  var firstVideo = $(".video-wrapper video")[0];
  if (firstVideo?.getAttribute("data-auto-play") === "true") {
    firstVideo
      .play()
      .then(() => {})
      .catch((error) => {
        setTimeout(() => {
          $(firstVideo).parent().removeClass("is_playing");
        }, 1000);
      });
  }
  $(".video-wrapper video").each(function () {
    var xx = $(this).attr("id");
    var videoElement = document.getElementById(xx);
    videoElement.playsinline = true;
    videoElement.play();
    if ($(this).attr("data-auto-play") === "true") {
      setTimeout(() => {
        videoElement.pause();
        videoElement.currentTime = 0;
        autoPlayVideo();
      }, 500);
    } else {
      setTimeout(() => {
        videoElement.pause();
        videoElement.currentTime = 0;
      }, 500);
    }
  });
}

function autoPlayVideo() {
  var allVideos = document?.querySelectorAll(
    ".main-custom-video .video-wrapper video"
  );

  if (allVideos.length != 0) {
    document
      .getElementById("lightbox-video-1")
      .closest(".video")
      .classList.add("is_playing");
    document.getElementById("lightbox-video-1").play();
    function playNextVideo(index) {
      allVideos[index].closest(".video").classList.remove("is_playing");
      allVideos[index].currentTime = 0;
      allVideos[index + 1].closest(".video").classList.add("is_playing");
      allVideos[index + 1].play();
    }

    for (var i = 0; i < allVideos.length - 1; i++) {
      allVideos[i].addEventListener(
        "ended",
        (function (index) {
          return function () {
            playNextVideo(index);
          };
        })(i)
      );
    }

    allVideos[allVideos.length - 1].addEventListener("ended", function () {
      allVideos[allVideos.length - 1]
        .closest(".video")
        .classList.remove("is_playing");
      allVideos[0].closest(".video").classList.add("is_playing");
      allVideos[0].play();
    });
  }
}

if (window.innerWidth > 990) {
  document
    .querySelectorAll(".main-custom-video .video-wrapper .video")
    .forEach(function (videoElement) {
      videoElement.addEventListener("click", function (event) {
        var videoSource = this.querySelector("video").getAttribute("src");
        var popupVideo = document.querySelector(
          ".custom_video_popup .custom_video_popup_wrapper video"
        );

        popupVideo.setAttribute("src", videoSource);
        document.querySelector(".custom_video_popup").classList.add("active");
        popupVideo.play();
        event.stopPropagation();
      });
    });
  $(document).on("click", function (event) {
    if (!$(event.target).closest(".custom_video_popup_wrapper").length) {
      $(".custom_video_popup").removeClass("active");
      $(".custom_video_popup .custom_video_popup_wrapper video").attr(
        "src",
        ""
      );
    }
  });

  $(".custom_video_popup .popup_close_btn").click(function () {
    $(".custom_video_popup .custom_video_popup_wrapper video").attr("src", "");
    $(".custom_video_popup").removeClass("active");
  });
}